import React from "react";
import OBD2Reader from "../components/OBD2Reader";

export default function OBD2Page() {
  return (
    <div style={{ padding: "1rem" }}>
      <h1>OBD-II Bluetooth Test</h1>
      <OBD2Reader />
    </div>
  );
}